// extracted by css-extract-rspack-plugin
export default {"textLink":"pN5Jaf","primary":"QDiauB","secondary":"ASRF7S"};